import { combineValidators, isRequired } from 'revalidate';

export const fieldsLabels = {
  email: 'Email',
};

export default combineValidators({
  email: isRequired(fieldsLabels.email),
});
